<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div class="ml5">
          任务名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.taskName"></a-input>
        </div>
        <div class="ml30">
          车辆编码
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.licenceNo"></a-input>
        </div>
        <div class="ml30">
          站点
          <a-select
              class="select-narrow ml24"
              placeholder="请选择站点"
              v-model:value="query.stopId"
              :options="stopOptions"
              :field-names="{ label: 'name', value: 'id' }"
              :filter-option="(input, option) => (option.name || '').includes(input)"
              show-search
              allow-clear
          ></a-select>
        </div>
        <div class="ml30">
          任务状态
          <a-select class="select-narrow ml24" placeholder="请选择" v-model:value="query.status" allow-clear>
            <a-select-option v-for="option in statusOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </a-select-option>
          </a-select>
        </div>
        <!-- <div class="ml30">
          创建时间
          <a-range-picker
              class="ml24"
              v-model:value="query.dateRange"
              format="YYYY-MM-DD"
              :placeholder="['开始日期', '结束日期']"
          />
        </div> -->
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">

      </div>
    </div>

    <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        size="middle"
        class="mt23"
        :scroll="{ x: 1500, y: 'auto' }"
        v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
        :data-source="dataSource"
        :pagination="pagination"
    >
      <template #bodyCell="{ column, record, index }">
        <span v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </span>
        <a-tag v-else-if="column.key === 'status'" :color="getStatusColor(record.status)">
          {{ getStatusLabel(record.status) }}
        </a-tag>
        <a-tag v-else-if="column.key === 'priority'" :color="getPriorityColor(record.priority)">
          {{ getPriorityLabel(record.priority) }}
        </a-tag>
        <div v-else-if="column.key === 'waypointNames'" class="waypoint-list">
          <template v-if="getWaypointNameList(record.waypointNames).length">
            <a-tag
                v-for="(name, i) in getWaypointNameList(record.waypointNames)"
                :key="i"
                class="waypoint-tag"
            >
              {{ name }}
            </a-tag>
          </template>
          <template v-else>-</template>
        </div>
        <span v-else-if="column.key === 'action'">
          <a v-if="record.status === 1 || record.status === -1  || record.status === 0" @click="handleDetail(record)">详情</a>
          <a v-if="record.status === 0" class="ml10" @click="handleReview(record)">审核</a>
        </span>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import { getTaskPageList } from "@/api/task/task.js";
import { getStopList } from "@/api/roads/stop.js";

const router = useRouter();

// 站点列表（用于站点下拉搜索）
const stopOptions = ref([]);
const loadStopList = async () => {
  try {
    const res = await getStopList();
    if (res.code === 200 && res.data) {
      stopOptions.value = res.data;
    }
  } catch (error) {
    console.error("获取站点列表失败:", error);
  }
};

const columns = [
  { title: "序号", key: "ranking", width: 60, fixed: "left" },
  { title: "主体企业", dataIndex: "deptName", key: "deptName", width: 180 },
  { title: "车辆编码", dataIndex: "licenceNo", key: "licenceNo", width: 120 },
  { title: "运营企业", dataIndex: "operatorName", key: "operatorName", width: 180 },
  { title: "线路名称", dataIndex: "routeName", key: "routeName", width: 200 },
  { title: "出发点", dataIndex: "originStopName", key: "originStopName", width: 150 },
  { title: "目的点", dataIndex: "destinationStopName", key: "destinationStopName", width: 150 },
  { title: "站点", dataIndex: "waypointNames", key: "waypointNames", width: 320 },
  { title: "状态", key: "status", width: 90 },

  { title: "开始时间", dataIndex: "startDate", key: "startDate", width: 120 },
  { title: "结束时间", dataIndex: "endDate", key: "endDate", width: 120 },
  { title: "创建时间", dataIndex: "createTime", key: "createTime", width: 160 },
  { title: "操作", key: "action", fixed: "right", width: 120 },
];

// 状态选项
const statusOptions = [
  { label: "待审核", value: 0, color: "processing" },
  { label: "已审核", value: 1, color: "success" },
];

// 优先级选项
const priorityOptions = [
  { label: "高", value: 1 },
  { label: "中", value: 2 },
  { label: "低", value: 3 },
];

const getStatusLabel = (value) =>
    statusOptions.find((o) => o.value === value)?.label || "-";

const getStatusColor = (value) =>
    statusOptions.find((o) => o.value === value)?.color || "default";

const getPriorityLabel = (value) =>
    priorityOptions.find((o) => o.value === value)?.label || "-";

const getPriorityColor = (value) => {
  if (value === 1) return "red";
  if (value === 2) return "orange";
  if (value === 3) return "blue";
  return "default";
};

// 解析站点名称列表（接口返回字符串数组，名称含 \r 换行符）
const getWaypointNameList = (names) => {
  if (!names) return [];
  if (Array.isArray(names)) {
    return names.map((n) => String(n).trim()).filter(Boolean);
  }
  const s = String(names).trim();
  return s ? [s] : [];
};

let dataSource = ref([]);

let query = reactive({
  taskName: "",
  licenceNo: "",
  stopId: undefined,
  status: undefined,
  dateRange: null,
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;
  getData();
}


const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.taskName = "";
  query.licenceNo = "";
  query.stopId = undefined;
  query.status = undefined;
  query.dateRange = null;
  pagination.current = 1;
  getData();
};

const getData = async () => {
  const conditionMap = {
    taskName: query.taskName || undefined,
    licenceNo: query.licenceNo || undefined,
    stopId: query.stopId,
    status: query.status,
  };
  if (query.dateRange && query.dateRange.length === 2) {
    conditionMap.startTime = dayjs(query.dateRange[0]).format("YYYY-MM-DD 00:00:00");
    conditionMap.endTime = dayjs(query.dateRange[1]).format("YYYY-MM-DD 23:59:59");
  }
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap,
  };
  try {
    const res = await getTaskPageList(data);
    if (res.code === 200) {
      dataSource.value = res.data.records || res.data.list || [];
      pagination.total = res.data.total || 0;
    }
  } catch (error) {
    console.error("获取任务列表失败:", error);
  }
};

const handleDetail = (record) => {
  router.push({ path: '/business/task-detail', query: { taskId: record.id } });
};

const handleReview = (record) => {
  router.push({ path: '/business/task-review', query: { taskId: record.id } });
};

onMounted(() => {
  getData();
  loadStopList();
});
</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.select-narrow {
  width: 8vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    align-items: center;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767e;
}

/deep/.ant-select-selector {
  background-color: #f2f4f7 !important;
  color: #68767e !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead > tr > th,
.ant-table-wrapper .ant-table-thead > tr > td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody > tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1e8ef2;
}

/deep/ .waypoint-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 4px;
}

/deep/ .waypoint-tag {
  margin: 0;
  writing-mode: vertical-rl;
  text-orientation: upright;
  white-space: nowrap;
  height: auto;
  line-height: 20px;
  padding: 4px 2px;
  background: #ffffff;
  color: #595959;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
</style>
